export default __webpack_public_path__ + "static/media/Summoner's Leggings of Prestige.cb7597ef.jpg";